import React, {useRef, useEffect} from 'react';
import nft from '../images/helpinghands.png';
import * as StyleFunctions from '../utilities/StyleFunctions';
import hourglass from '../images/hourglass.png' ;

function App(props) {

  var parentalType = props.parentalType;
  var thisItem = props.thisItem;
  var allStyles = props.allStyles;
  var stylesToAdd = props.stylesToAdd;
  var height = props.height;
  var width = props.width;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var inputValues = props.inputValues;
  var upwardInfo = props.upwardInfo;
  var actHoveringWhere = props.actHoveringWhere;
  var clickFn = props.clickFn;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var addClassNames = props.addClassNames;
  var addCCColWidth = props.addCCColWidth;
  var draggable = props.draggable;
  var onDrag = props.onDrag;
  var onDragStart = props.onDragStart;
  var onDragEnd = props.onDragEnd;
  var itemInfoPath = props.itemInfoPath;
  var doAScreenRef = props.doAScreenRef;
  var itemInfoPathString = props.itemInfoPathString;
  var chains = props.chains;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemInfoPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


    stylesToAdd.padding = allStyles.padding;
    stylesToAdd.paddingLeft = allStyles.paddingLeft;
    stylesToAdd.paddingTop = allStyles.paddingTop;
    stylesToAdd.paddingRight = allStyles.paddingRight;
    stylesToAdd.paddingBottom = allStyles.paddingBottom;

    delete allStyles.padding;
    delete allStyles.paddingLeft;
    delete allStyles.paddingRight;
    delete allStyles.paddingBottom;
    delete allStyles.paddingTop;    


    var src = nft;
    if (allStyles.src){
      src = allStyles.src;
    }
    if (src.e){
      src = '';
    }else if (src === '' || src === '-'){
      src = hourglass;
    }

    if (src.indexOf('ipfs://') === 0){
      src = 'https://ipfs.io/ipfs/' + src.substr(7);
      // src = 'https://bushicro.mypinata.cloud/ipfs/' + src.substr(7) + '?pinataGatewayToken=G8NWjBrx_74Dy55cv3YnnTofKhpbqezpLFib6svdXZYiACRcjyBawGgJuDgtoYaZ';
    }

    if (parentalType || itemInfoPath[4] === 'k'){
      if (allStyles.wh){
        delete allStyles.width;
      }else{
        delete allStyles.height;
      }

      var addClassNamesHereV = StyleFunctions.iterateClassNames('', ['vTop'], allStyles);

      return  <div ref={ref1} style={stylesToAdd} className={addClassNames + addCCColWidth + addClassNamesHereV} onClick={clickFn} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd}><img alt='generatedImage' key={itemInfoPathString} src={src} style={allStyles} draggable={false}/></div>
//      
      // return  <img alt='generatedImage' key={itemInfoPathString} className={addClassNames + addCCColWidth} onClick={clickFn} src={src} style={{...allStyles, ...stylesToAdd}} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}/>

    }else{

      var allInfo = StyleFunctions.evaluateStyleR('IMGINFO', thisItem.info, itemInfoPath.concat(['info']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);

      var className1 = StyleFunctions.iterateClassNames('img-fluid', [], allStyles);

      stylesToAdd.overflow = 'hidden';
      var desiredWidth = stylesToAdd.width;
      var realH = allInfo.sca * (stylesToAdd.oH - allInfo.cT - allInfo.cB);
      var realW = (stylesToAdd.oW - allInfo.cL - allInfo.cR);    
      var desiredHeight = desiredWidth * realH / realW;
      stylesToAdd.height = desiredHeight;

      var scaleRequired = desiredWidth / realW;

      allStyles.position = 'absolute';
      allStyles.left = - allInfo.cL * scaleRequired;
      allStyles.top = - allInfo.cT * scaleRequired;
      allStyles.width = stylesToAdd.oW * scaleRequired;
      allStyles.height = stylesToAdd.oH *  allInfo.sca * scaleRequired;

      stylesToAdd.zIndex = allStyles.zIndex;
      return <div style={stylesToAdd} key={itemInfoPathString} ref={ref1} >
        <img alt='generatedImage' className={className1} onClick={clickFn} src={src} style={allStyles} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} onMouseOver={actHoveringWhere(itemInfoPathString)} onMouseOut={actHoveringWhere('')}/>
        </div>      
    }

}
//




export default App;
